export default "__VITE_ASSET__Bv5LzF30__"